var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopSound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 11,
  viewBox: "0 0 11 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.481 8.624V2.215l5.297-.882v6H8.216c-.895 0-1.697.502-1.697 1.29 0 .789.802 1.29 1.697 1.29h1.086c.895 0 1.698-.501 1.698-1.29V.612a.61.61 0 0 0-.712-.603L3.77 1.095a.61.61 0 0 0-.51.603v6.314H1.697C.803 8.012 0 8.514 0 9.302c0 .79.803 1.29 1.698 1.29h1.086c.895 0 1.697-.5 1.697-1.29v-.678"
})));
export default SvgTiktokDesktopSound;